import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/dialog-sc-request-code.json'
import Button from 'src/components/Button'

import classes from '../styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  goToRecaptchaStep: () => void
}

export default function ButtonGetRequest(props: Props) {
  return (
    <>
      <p className='mt-typography-body1'>{t('step1')}</p>
      <Button type='submit' onClick={() => props.goToRecaptchaStep()} className={classes.btnRequest}>
        {t('btn_request')}
      </Button>
    </>
  )
}
